var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"form-control",attrs:{"required":_vm.required,"max":_vm.max,"min":_vm.min,"disabled":_vm.disabled,"type":"number"},domProps:{"value":_vm.numericValue},on:{"input":_vm.entryChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }